define('glu/$window',['require','./$','./appBus','./util'],function(require) {
    'use strict';

    var $ = require('./$'),
        appBus = require('./appBus'),
        util = require('./util');

    var $window = $(window);

    $window.on('resize.global', util.debounce(function(event) {
        appBus.trigger('resize', event);
    }, 100));

    return $window;
});

